/** Gift vouchers are not offered on the Ireland site (siteId 11). */
const GIFT_VOUCHERS_DISABLED_SITE_IDS = [11];

export function isGiftVouchersEnabledForSite(
  siteId: number = +process.env.NEXT_PUBLIC_SITE_ID
): boolean {
  return !GIFT_VOUCHERS_DISABLED_SITE_IDS.includes(siteId);
}

export function isGiftVoucherPath(slug: string | null | undefined): boolean {
  return Boolean(slug?.startsWith('/gift-vouchers'));
}
